import styled from '@emotion/styled';
import { ColorSelect } from '../../ColorSelect';
import { Spinner } from '../../presentation/Spinner';

export type TagDetailsColorSelectProps = {
  label?: string;
  color: string;
  onChange: (color: string) => void;
  isPending?: boolean;
};

export const TagDetailsColorSelect = ({
  label = 'Color',
  color,
  onChange,
  isPending = false,
}: TagDetailsColorSelectProps) => (
  <Root>
    <Label>{label}</Label>
    <Value>
      {isPending ? (
        <SpinnerWrap>
          <Spinner />
        </SpinnerWrap>
      ) : (
        <ColorSelect color={color} onChange={onChange} />
      )}
    </Value>
  </Root>
);

TagDetailsColorSelect.displayName = 'TagDetails.ColorSelect';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.div`
  font-family: var(--font-bold);
  color: var(--gray-d);
  font-size: 14px;
`;

const Value = styled.div`
  min-height: 20px;
  display: flex;
  align-items: center;
`;

const SpinnerWrap = styled.div`
  display: flex;
  align-items: center;
`;
